import React from 'react'
import styled from 'styled-components'
import Option from './Option'
import { Droppable } from 'react-beautiful-dnd'

function Column(props) {

  const Container = styled.div`
    border: ${props.column.id === "options" ? "1px" : "5px"} solid ${props => props.theme.borderColor};
    border-radius: 2px;
    display: flex;
    flex-direction: column;
    min-height: 50px;
    padding: 8px;
    width: 100%;
  `
  
  const Title = styled.div`
    padding: 4px;
    text-align: center;
    color: ${props => props.theme.borderColor};
    font-size: 14pt;
  `
  const OptionList = styled.div`
    padding-left: 8px;
    padding-right: 8px;
    transition: background-color 0.2s ease;
    background-color: ${props =>
      props.isDraggingOver ? '#B2292D' : 'white'}
    flex-grow: 1;
    min-height: 30px;
  `

    return (
        <Container >
            {/* {props.column.id === "options" ? <Title>{props.column.title}</Title> : null } */}
            <Droppable droppableId={props.column.id} type="TASK" >
            {(provided, snapshot) => (
                <OptionList
                ref={provided.innerRef}
                {...provided.droppableProps}
                isDraggingOver={snapshot.isDraggingOver}
                >
                {props.options.map((option, index) => (
                    <Option key={option.id} option={option} index={index} isDisabled={props.isDisabled} />
                ))}
                {provided.placeholder}
                </OptionList>
            )}
            </Droppable>
        </Container>
        )
    }

export default Column;